import { render } from "./AboutDogs.vue?vue&type=template&id=50cdc7bc&scoped=true"
import script from "./AboutDogs.vue?vue&type=script&lang=js"
export * from "./AboutDogs.vue?vue&type=script&lang=js"

import "./AboutDogs.vue?vue&type=style&index=0&id=50cdc7bc&scoped=true&lang=css"

import exportComponent from "/Users/jessicabohland/Documents/Code/Website/gonsbachtal-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50cdc7bc"]])

export default __exports__